import { useQuery } from "@tanstack/react-query";
import {
  awardsApi,
  promotionCreditsApi,
  type AwardGivingBudgetResponse,
  type PromotionCreditBalanceResponse,
  type ReputationResponse,
} from "lib/api";

export const awardQueryKeys = {
  budget: () => ["awardBudget"] as const,
  balance: () => ["awardBudget"] as const,
  reputation: (actorType: string, actorId: number | string) =>
    ["reputation", actorType, String(actorId)] as const,
};

export const promotionCreditQueryKeys = {
  balance: () => ["promotionCreditBalance"] as const,
};

export const useAwardGivingBudgetQuery = (enabled = true) =>
  useQuery<AwardGivingBudgetResponse>({
    queryKey: awardQueryKeys.budget(),
    queryFn: () => awardsApi.getBudget(),
    enabled,
    staleTime: 30_000,
  });

export const useAwardBalanceQuery = useAwardGivingBudgetQuery;

export const usePromotionCreditBalanceQuery = (enabled = true) =>
  useQuery<PromotionCreditBalanceResponse>({
    queryKey: promotionCreditQueryKeys.balance(),
    queryFn: () => promotionCreditsApi.getBalance(),
    enabled,
    staleTime: 30_000,
  });

export const useReputationQuery = (
  actorType: string | null | undefined,
  actorId: number | string | null | undefined,
  enabled = true
) =>
  useQuery<ReputationResponse>({
    queryKey: actorType && actorId ? awardQueryKeys.reputation(actorType, actorId) : ["reputation", "empty"],
    queryFn: () => awardsApi.getReputation(actorType as string, actorId as number | string),
    enabled: enabled && Boolean(actorType) && actorId !== null && actorId !== undefined,
    staleTime: 60_000,
  });
